import { createContext, useContext, useState } from 'react';

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [activeBrand, setActiveBrand] = useState(null);

  return (
    <BrandContext.Provider value={{ activeBrand, setActiveBrand }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrand must be used within BrandProvider');
  return ctx;
}
